import type { PropType } from 'vue'

const predefinedSizes = ['small', 'default', 'large'] as const

type Sizes = typeof predefinedSizes[number]

export interface SizeProps {
  size: Sizes
}

export const useSizeProps = () => ({
  size: {
    type: String as PropType<Sizes>,
    default: 'default',
    validator: (value: Sizes) => predefinedSizes.includes(value),
  },
})
